<template>
  <FormGroup v-if="contactCapture.isFieldVisible(name)" :id="id" :label="label">
    <VueSelect
      v-model="selectedValue"
      append-to-body
      :calculate-position="useVueSelectDropdownPosition"
      class="form-control"
      label="text"
      :clearable="false"
      :disabled="disabled"
      :filterable="true"
      :id="id"
      :options="options"
    >
      <template #open-indicator>
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
        >
          <path d="M1.41 1L6 5.58 10.59 1 12 2.41 6 8.41 0 2.41 1.41 1z" />
        </svg>
      </template>
    </VueSelect>
  </FormGroup>
</template>

<style scoped>
/* Nice scrolling inside the menu */
.vs__dropdown-menu {
  --vs-dropdown-z-index: 1500;
  box-sizing: border-box;
}
</style>

<script setup lang="ts">
import { useContactCaptureContext } from "@/components/forms/useContactCapture";
import { useVueSelectDropdownPosition } from "@/hooks/useVueSelectDropdownPosition";
import { Country, fetchCoutnries } from "@/lib/fetchCoutnries";
import { uniqueId } from "underscore";
import { useField } from "vee-validate";
import { computed, onBeforeMount, ref, watch } from "vue";
import VueSelect from "vue-select";
import { RegionHelper } from "../../common/region_helper";
import FormGroup from "./FormGroup.vue";

type Props = {
  id?: string;
  name: string;
  label: string;
};

const props = defineProps<Props>();

const id = props.id ?? uniqueId("field-");
const selectedValue = ref<Country | null>(null);
const options = ref<Country[]>([]);

const contactCapture = useContactCaptureContext();

const disabled = computed(() => !!contactCapture.org_id.value);

const { setValue } = useField<number | null | undefined>(
  () => props.name ?? props.id
);

onBeforeMount(() => {
  getCountries().then(() => {
    const { spirit_country_code } = RegionHelper.getSelectedRegion();

    if (spirit_country_code && contactCapture) {
      contactCapture.country.value = Number(spirit_country_code);
    }
  });
});

watch(contactCapture.country, () => {
  setValue(contactCapture.country.value);

  const option = options.value.find(
    (country) => country.id === contactCapture.country.value
  );

  if (option) {
    selectedValue.value = option;
  }
});

watch(selectedValue, () => {
  if (contactCapture) {
    contactCapture.country.value = selectedValue.value?.id ?? null;
  }
});

async function getCountries() {
  try {
    options.value = await fetchCoutnries();
  } catch (error) {
    console.error("Error while fetching countries.", error);
  }
}
</script>
